import * as React from 'react';
import { generateInnerHtml } from 'shared-react';

import ErrorMessage from '../Notifications/ErrorMessage/ErrorMessage';
import './TextViewer.scss';

interface TextViewerProps {
  htmlText: string;
  error?: string;
}

class TextViewer extends React.Component<TextViewerProps> {
  render() {
    const { htmlText, error } = this.props;

    return (
      <React.Fragment>
        <div
          className="TextViewer-htmlText"
          // We allow img here in addition to other tags because we embed images
          {...generateInnerHtml(htmlText, ['img'])}
        />
        <div className="TextViewer-normalizeWidthWrapper">{error && <ErrorMessage errorText={error} />}</div>
      </React.Fragment>
    );
  }
}

export default TextViewer;
